import React, { useEffect, useState, Fragment } from 'react';
import { Pagination, PageHeader, paginate } from '../../../Common';
import { TableContent } from '../../Common/Table/tableContent';
import { taskSchemaObject } from '../taskSchema'
import services from '../services';
import $ from 'jquery';
import { validateProperty, } from "../../Common";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import Joi from '@hapi/joi';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';

const screenCode = 'TASK';

export function TaskListing(props) {

    const [estates, setEstates] = useState()
    const [allTask, setAllTask] = useState([])
    const [groups, setGroups] = useState();
    const [searchForm, setSearchForm] = useState({
        groupID: 0,
        operationEntityID: 0,
    });
    const contentRowNames = ["taskCode", "taskName", "estateTaskName", "isActive"];
    const [errors, setErrors] = useState({});
    const [isTableHide, setIsTableHide] = useState(true);
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(taskSchemaObject).options({ allowUnknown: true })


    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, []);

    useEffect(() => {
        trackPromise(
            getEstates()
        )
    }, [searchForm.groupID]);

    useEffect(() => {
        if (searchForm.operationEntityID != 0) {
            handleSearch()

        }
    }, [searchForm.operationEntityID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWTASKLISTING');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITTASK');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setSearchForm({
            ...searchForm,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        getAllGroups();
    }

    async function getEstates() {
        const result = await services.GetAllOperationEntityByGroupID(searchForm.groupID)
        setEstates(result)
    }

    async function getAllGroups() {
        const result = await services.getGroups()
        setGroups(result)
    }


    async function getAllTask(operationEntityID) {
        const data = await services.getAllByFilter(operationEntityID);
        return data;
    }

    function destroyDataTable() {
        setIsTableHide(true);
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
        setIsTableHide(false);
    }


    function handleClick(item) {
        props.history.push({
            pathname: 'task/addEdit',
            data: item,
            edit: true,
            searchForm: searchForm
        })
    }

    function handleGroupChange(target) {
        validateInputs(target);

        setSearchForm({
            ...searchForm,
            groupID: target.value,
            operationEntityID: '0'
        })
    }

    function handleOperationEntityChange(target) {
        validateInputs(target);
        setSearchForm({
            ...searchForm,
            operationEntityID: target.value
        })
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, taskSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setErrors(error)

    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }

    async function handleSearch() {
        destroyDataTable();
        var data = await getAllTask(searchForm.operationEntityID);
        setAllTask(data)
        createDataTable();
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Tasks"
                            isButtonEnable={permissionList.isAddEditEnabled}
                            buttonText="Add Task"
                            path="task/addEdit" />

                        <div className="card-body">

                            <form onSubmit={(e) => trackPromise(handleSearch(e))}>

                                <div className="form-group row">

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            name="groupID"
                                            value={searchForm.groupID}
                                            onChange={(e) => handleGroupChange(e.target)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            value={searchForm.operationEntityID}
                                            onChange={(e) => handleOperationEntityChange(e.target)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>

                                </div>

                            </form>
                            <div className="table-responsive row-top-gap" hidden={isTableHide}>
                                <table id="example" className="display dataTable no-footer">
                                    <thead>
                                        <tr>
                                            <th>Task Code</th>
                                            <th>Task Name</th>
                                            <th>Task Category</th>
                                            <th>Status</th>
                                            {permissionList.isAddEditEnabled ? <th>Action</th> : null}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <TableContent
                                            data={allTask}
                                            hasEdit={permissionList.isAddEditEnabled}
                                            contentRowNames={contentRowNames}
                                            handleClick={handleClick}
                                        />
                                    </tbody>
                                </table>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}


